import { Container } from 'react-bootstrap';
import '../style/contact.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { db } from '../database/firebase';
import { collection,addDoc } from 'firebase/firestore';
import { useState } from 'react';
export default function Contact() {
  const[message,setmessage]=useState({
    name:"",
    email:"",
    message:""
  });
  const [validated, setValidated] = useState(false);
const[emessage,setemessage]=useState("");


  const[loding,setloding]=useState(false);
  /*add */
  const addmessage = async () => {
    setemessage("")
    setloding(true);
    try {
      const docRef = await addDoc(collection(db, "message"), {
      name:message.name,
      email:message.email,
      message:message.message,
      });
      console.log("Document ID:", docRef.id);
      setloding(false);
      setmessage({name:"",email:"",message:""})
     
    } catch (error) {
      console.error("Error adding document:", error);
    }
  };
  /*add*/
  return (
    <div className='contact'>
      <Container>
        <div className='inside-contact'>
          <div className='find-us'>
            <h2>Finden Sie uns</h2>
            <div className='items'>
              <i class='fa-solid fa-phone-volume'></i>
              <div className='item-content'>
                <h4>Rufen Sie uns an</h4>
                <h5>+4917645345111</h5>
              </div>
            </div>

            <div className='items'>
              <i class='fa-solid fa-envelope'></i>
              <div className='item-content'>
                <h4>Jetzt per E-Mail senden</h4>
                <h5>Info-Lamar@t-online.de</h5>
              </div>
            </div>

            <div className='items'>
              <i class='fa-solid fa-location-dot'></i>
              <div className='item-content'>
                <h4>Adresse</h4>
                <h5>Moltkestr. 35, 76133 Karlsruhe</h5>
              </div>
            </div>
          </div>

          <div className='touch'>
            <h5>Kontaktinformationen</h5>
            <h3>Den Kontakt halten</h3>
            <p>
              Wir legen größten Wert darauf, Ihre Anfragen umgehend zu
              beantworten, um sicherzustellen, dass Sie zeitnah die benötigte
              Unterstützung erhalten.
            </p>
            <div style={{textAlign:"center" ,color:"red"}}>{emessage}</div>
            <Form  >
      
            <Form.Group  className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>Name</Form.Label>
        <Form.Control  type="text" value={message.name} onChange={(e)=>setmessage({...message,name:e.target.value})} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>E-Mail-Adresse</Form.Label>
        <Form.Control type="email" placeholder="name@example.com" value={message.email} onChange={(e)=>setmessage({...message,email:e.target.value})}/>
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
        <Form.Label>Nachricht</Form.Label>
        <Form.Control as="textarea" rows={3} value={message.message} onChange={(e)=>setmessage({...message,message:e.target.value})}/>
      </Form.Group>
    </Form>
    <Button variant="success"  onClick={()=>message.name!==""&&message.email!==""&&message.message!=="" ? addmessage():setemessage("Kein Feld darf leer bleiben")}>{loding ? "Senden.....":"Massage geschickt"}</Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
